import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JointCompletionCertificate } from '../../models/reports/joint-completion-certificate.model';
import { JointCompletionForm } from '../../models/reports/joint-completion-form.model';
import { ReportViewerComponent } from '../report-viewer/report-viewer.component';
import { CalculationResult } from '../../models/calculationModels';

import { ReportApiService } from 'src/app/services/report.api.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { DataSheetReport } from '../../models/reports/data-sheet-report.model';
import { ITRReport } from '../../models/reports/itr-report.model';
import { ManagementApiService } from 'src/app/services/management-api.service';

@Component({
    selector: 'app-joint-completion-report',
    templateUrl: './joint-completion-report.component.html',
    styleUrls: ['./joint-completion-report.component.scss'],
    standalone: false
})
export class JointCompletionReportComponent implements OnInit {
    @Input() calculationResult: CalculationResult;

    jointCompletionReportData: JointCompletionCertificate[] | DataSheetReport[] | ITRReport[];
    jointCompletionForm: UntypedFormGroup;
    jointCompletionFormValues: JointCompletionForm;
    reportData: DataSheetReport | JointCompletionCertificate | DataSheetReport[] | JointCompletionCertificate[];

    constructor(
        private formBuilder: UntypedFormBuilder,
        private ngbModal: NgbModal,
        private ngbActiveModal: NgbActiveModal,
        private reportApiService: ReportApiService,
        private userUtilityService: UserUtilityService,
        private ngXUiLoaderService: NgxUiLoaderService,
        private managementApiService: ManagementApiService
    ) {}

    ngOnInit(): void {
        this.createFormControls();
    }

    // function to create the formControls
    createFormControls() {
        this.jointCompletionForm = this.formBuilder.group({
            customer: [null],
            projectNumber: [null],
            joint_id: [null],
            vessel_ref: [null],
            permanent_tag: [null],
            pid_number: [null],
            bolt_coating: [null],
            site: [null],
            project_name: [null],
            joint_location: [null],
            work_pack: [null],
            line_number: [null],
            iso_number: [null],
            gasket_filter: [null],
            pump_gauge_serial_no: [null],
            tool_serial_no: [null],
            reference_document: [null],
            instructed_by: [null],
            instructed_company: [null],
            instructed_position: [null],
            assembled_by: [null],
            assembled_company: [null],
            assembled_date: [null],
            tightened_by_one: [null],
            tightened_by_one_company: [null],
            tightened_by_one_date: [null],
            tightened_by_two: [null],
            tightened_by_two_company: [null],
            tightened_by_two_date: [null],
            report_completed: [null],
            report_completed_date: [null],
            customer_acceptance: [null],
            customer_acceptance_company: [null],
            customer_acceptance_date: [null],
            comments: [null],
        });
    }

    // get formControls value
    getFormControlValues() {
        let jointCompletionFormValues = new JointCompletionForm();
        jointCompletionFormValues.customer = this.jointCompletionForm.get('customer').value;
        jointCompletionFormValues.projectnumber = this.jointCompletionForm.get('projectNumber').value;
        jointCompletionFormValues.jointid = this.jointCompletionForm.get('joint_id').value;
        jointCompletionFormValues.vesselref = this.jointCompletionForm.get('vessel_ref').value;
        jointCompletionFormValues.permanenttag = this.jointCompletionForm.get('permanent_tag').value;
        jointCompletionFormValues.pidnumber = this.jointCompletionForm.get('pid_number').value;
        jointCompletionFormValues.boltcoating = this.jointCompletionForm.get('bolt_coating').value;
        jointCompletionFormValues.site = this.jointCompletionForm.get('site').value;
        jointCompletionFormValues.projectname = this.jointCompletionForm.get('project_name').value;
        jointCompletionFormValues.jointlocation = this.jointCompletionForm.get('joint_location').value;
        jointCompletionFormValues.workpack = this.jointCompletionForm.get('work_pack').value;
        jointCompletionFormValues.linenumber = this.jointCompletionForm.get('line_number').value;
        jointCompletionFormValues.isonumber = this.jointCompletionForm.get('iso_number').value;
        jointCompletionFormValues.gasketfilter = this.jointCompletionForm.get('gasket_filter').value;
        jointCompletionFormValues.gaugeserialnumber = this.jointCompletionForm.get('pump_gauge_serial_no').value;
        jointCompletionFormValues.toolserialnumber = this.jointCompletionForm.get('tool_serial_no').value;
        jointCompletionFormValues.referencedocument = this.jointCompletionForm.get('reference_document').value;
        jointCompletionFormValues.instructedby = this.jointCompletionForm.get('instructed_by').value;
        jointCompletionFormValues.instructedcompany = this.jointCompletionForm.get('instructed_company').value;
        jointCompletionFormValues.instructedposition = this.jointCompletionForm.get('instructed_position').value;
        jointCompletionFormValues.assembledby = this.jointCompletionForm.get('assembled_by').value;
        jointCompletionFormValues.assembledcompany = this.jointCompletionForm.get('assembled_company').value;
        jointCompletionFormValues.assembleddate = this.jointCompletionForm.get('assembled_date').value;
        jointCompletionFormValues.tightenedbyone = this.jointCompletionForm.get('tightened_by_one').value;
        jointCompletionFormValues.tightenedbyonedate = this.jointCompletionForm.get('tightened_by_one_date').value;
        jointCompletionFormValues.tightenedby1company = this.jointCompletionForm.get('tightened_by_one_company').value;
        jointCompletionFormValues.tightenedbyonedate = this.jointCompletionForm.get('tightened_by_one_date').value;
        jointCompletionFormValues.tightenedbytwo = this.jointCompletionForm.get('tightened_by_two').value;
        jointCompletionFormValues.tightenedby2company = this.jointCompletionForm.get('tightened_by_two_company').value;
        jointCompletionFormValues.tightenedbytwodate = this.jointCompletionForm.get('tightened_by_two_date').value;
        jointCompletionFormValues.reportcompleted = this.jointCompletionForm.get('report_completed').value;
        jointCompletionFormValues.reportcompleteddate = this.jointCompletionForm.get('report_completed_date').value;
        jointCompletionFormValues.customeracceptance = this.jointCompletionForm.get('customer_acceptance').value;
        jointCompletionFormValues.customeracceptancecompany = this.jointCompletionForm.get('customer_acceptance_company').value;
        jointCompletionFormValues.customeracceptancedate = this.jointCompletionForm.get('customer_acceptance_date').value;
        jointCompletionFormValues.comments = this.jointCompletionForm.get('comments').value;
        jointCompletionFormValues.jointcalculation = this.calculationResult;
        return jointCompletionFormValues;
    }

    // continue button click
    async continueButtonClick() {
        this.jointCompletionFormValues = this.getFormControlValues();
        let payload: any = {};
        payload.criteria = [];

        let DataContent = JSON.stringify(this.jointCompletionFormValues);
        payload.criteria.push({ DataContent: DataContent });
        this.ngXUiLoaderService.start();

         try {
            await this.reportApiService.callReports('JoinCompletionCertificateReport', payload, 'getjointcompletioncertificate');
            this.ngbActiveModal.close();
            this.ngXUiLoaderService.stop();
        } catch (error) {
            this.userUtilityService.errorModelPopup(error.message);
            this.ngbActiveModal.close();
            this.ngXUiLoaderService.stop();
        }
    }

    closeModal() {
        // will be implemented
        this.ngbActiveModal.close();
    }

    initFormControlValues() {
        this.jointCompletionForm = this.formBuilder.group({
            customer: ['Test Customer', null],
            projectNumber: ['Test Project number', null],
            joint_id: ['Test joint id', null],
            vessel_ref: ['Test vessel ref', null],
            permanent_tag: ['test permanent tag', null],
            pid_number: ['Test PID number', null],
            bolt_coating: ['Test bolt coating', null],
            site: ['Test site', null],
            project_name: ['Test Project Name', null],
            joint_location: ['Test joint location', null],
            work_pack: ['Test Work pack', null],
            line_number: ['Test Line Number', null],
            iso_number: ['Test ISO number', null],
            gasket_filter: ['Test Gasket Filter', null],
            reference_document: ['Test Reference document', null],
            instructed_by: ['Test instructed by', null],
            instructed_company: ['Test instructed company', null],
            instructed_position: ['Test instructed position', null],
            assembled_by: ['Test assembled by', null],
            assembled_company: ['Test assembled company', null],
            assembled_date: [new Date(), null],
            tightened_by_one: ['test tightened by one', null],
            tightened_by_one_date: [new Date(), null],
            tightened_by_two: ['test tightened by two', null],
            tightened_by_two_date: [new Date(), null],
            report_completed: ['Test report completed by', null],
            report_completed_date: [new Date(), null],
            customer_acceptance: ['Test customer acceptance', null],
            customer_acceptance_company: ['Test customer acceptance', null],
            customer_acceptance_date: [new Date(), null],
            comments: ['Test Comments goes here', null],
        });
    }
}
